const getSecondsFromTimeString = function(timeString="",sep=":") {
    let seconds = 0;
    if(typeof timeString === "string") {
        timeString.split(sep).reverse().forEach((val, index) => {
            seconds += parseInt(val) * (60 ** index);
        })
    }
    else {
        seconds = timeString;
    }
    return seconds;
}

export default getSecondsFromTimeString